import {adjustToTimeZoneSafely, type EntityObject, getObjectId} from "@ots-frontend/ots-data";
import type {ShiftDraft} from "@ots-frontend/ots-ui-tw";

/** What pages pass when they open `/shifts/form`: a shift to edit or copy, or the old form's defaults. */
export type ShiftFormRouteState = {
  id?: string;
  copy?: boolean;
  /** The Mantine shift form's values: times on the app time zone's wall clock, entities or their ids. */
  formDefaults?: {
    startDate?: Date;
    endDate?: Date;
    preTripDate?: Date;
    postTripDate?: Date;
    person?: string | EntityObject;
    vehicle?: string | EntityObject;
    trailer?: string | EntityObject;
  };
};

const instant = (date: Date | undefined) => adjustToTimeZoneSafely(date)?.getTime();

/** A new shift's draft from the old form's defaults, which the legacy driver activity menu still sends. */
export const shiftDraftFromRouteState = (state: ShiftFormRouteState | null | undefined): ShiftDraft | undefined => {
  const defaults = state?.formDefaults;
  if (!defaults) return undefined;
  const draft: ShiftDraft = {
    personId: getObjectId(defaults.person),
    vehicleId: getObjectId(defaults.vehicle),
    trailerId: getObjectId(defaults.trailer),
    startDttm: instant(defaults.startDate),
    endDttm: instant(defaults.endDate),
    preDttm: instant(defaults.preTripDate),
    postDttm: instant(defaults.postTripDate),
  };
  return Object.fromEntries(Object.entries(draft).filter(([, value]) => value !== undefined)) as ShiftDraft;
};
